import { useState } from 'react'
import AddContactModal from './AddContactModal'

export default function ContactActionsBar({ tenantId, defaultStage, onContactCreated, onImportClick }) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <div className="flex gap-2">
        <button
          onClick={() => setModalOpen(true)}
          className="flex items-center gap-1.5 bg-[#1535c8] text-white text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-[#1228a8] transition-colors"
        >
          <span>+</span>
          <span>Add Contact</span>
        </button>
        <button
          onClick={onImportClick}
          className="flex items-center gap-1.5 border border-gray-300 text-gray-600 text-sm font-semibold px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <span>&#8679;</span>
          <span>Import</span>
        </button>
      </div>

      <AddContactModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        tenantId={tenantId}
        defaultStage={defaultStage}
        onCreated={contact => { onContactCreated && onContactCreated(contact) }}
      />
    </>
  )
}
